// extracted by mini-css-extract-plugin
export default {"container":"x9TgfehAxeOTnoaOYeI3","dot":"ZuqZiVE3bUuATxxIAMDw","active":"PUxTRkZBunYBMl7ON9w0","offText":"vpKWeSWziecQGiZg9K_y","onText":"nyR7Dgcx0YlS543mqdGs"};